export default "__VITE_ASSET__BixO3TKn__"